import { ReactElement } from 'react'
import { ProjectDetailsIndex } from 'src/screens/shared/project/details/ProjectDetailsIndex'

export const PfPgvProjectDetailsIndexPage = (): ReactElement => {
  return <ProjectDetailsIndex baseUrl="/pf-pgv" />
}
